import * as Styled from './SecondaryNav.styles';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { error } from '@innovyze/stylovyze/lib/actions';
import SplitButton from '@innovyze/stylovyze/lib/components/SplitButton';
import SecondaryNavItems from './SecondaryNavItems';
/**
 * Secondary navigation bar
 */
export const SecondaryNav = ({ heading, items, cancelButton, actionButton, actionOptions, itemIndex = 0, itemIndexChanged, beforeItemIndexChanged, backLink, className, isLoading, applyPadding, tabSecondary, onlyShowSeveralTabs, }) => {
    const dispatch = useDispatch();
    const [index, setIndex] = useState(itemIndex);
    const { content } = (items || [])[index] ?? {};
    const changeTab = (tabIndex) => () => {
        let event = {
            cancelled: false,
            fromIndex: index,
            toIndex: tabIndex,
        };
        if (beforeItemIndexChanged) {
            event = beforeItemIndexChanged(event);
        }
        const disabled = items?.[tabIndex].disabled;
        if (disabled) {
            dispatch(error(items?.[tabIndex].disabledMessage ??
                'This section cannot be shown'));
            return;
        }
        if (event && !event.cancelled) {
            (itemIndexChanged || setIndex)(tabIndex);
        }
    };
    useEffect(() => {
        setIndex(itemIndex);
    }, [itemIndex]);
    const backLinkProps = {
        ...(backLink?.to && { to: backLink.to, component: Link }),
        ...(!backLink?.to &&
            backLink?.onClick && { onClick: backLink.onClick }),
    };
    return (React.createElement(Styled.Wrapper, null,
        backLink && (React.createElement(Styled.BackLink, { ...backLinkProps },
            React.createElement(Styled.ArrowBack, null),
            " ",
            backLink?.title)),
        (heading || actionButton || actionOptions || cancelButton) && (React.createElement(Styled.Header, null,
            React.createElement("h1", null, heading),
            cancelButton && (React.createElement(Styled.CancelButton, { onClick: cancelButton.onClick }, cancelButton.title)),
            actionButton && (React.createElement(Styled.ActionButton, { onClick: actionButton.onClick, color: "primary", disabled: !actionButton.enabled }, actionButton.title)),
            actionOptions && React.createElement(SplitButton, { options: actionOptions }))),
        items && (React.createElement(SecondaryNavItems, { changeTab: changeTab, index: index, items: items, applyPadding: applyPadding, className: className, key: index, tabSecondary: tabSecondary, onlyShowSeveralTabs: onlyShowSeveralTabs })),
        !isLoading && React.createElement(Styled.Content, null, content)));
};
SecondaryNav.defaultProps = {
    isLoading: false,
    applyPadding: true,
};
export default SecondaryNav;
